import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import './styles.scss';
import { colors } from '../../../style/constants';
import { useLocaleReceiver } from '../../../locales/LocaleReceiver';
function ErrorBoundaryFallbackComponent() {
  const $ = _c(5);
  const intl = useLocaleReceiver("FallbackError");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FontAwesomeIcon icon={faExclamationCircle} color={colors.feedbackDestructive400} size="lg" className="u-margin-right--small" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== intl) {
    t1 = intl.formatMessage({
      id: "title"
    }, {
      link: intl.formatMessage({
        id: "linkText"
      })
    });
    $[1] = intl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="app-fallback-error">{t0}<span>{t1}</span></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default ErrorBoundaryFallbackComponent;